import { Routes, Route, Navigate } from 'react-router-dom'

import MainPage from './pages/Main'
import BurggerPage from './pages/Burggers'
import PizzaPage from './pages/Pizzas'
import DrinkPage from './pages/Drinks'
import IceCreamPage from './pages/IceCream'
import MycartPage from './pages/MyCart'
import PaymentPage from './pages/Payment'
import AdminPage from './pages/Admin'
import AdminPedidos from './pages/Admin/AdminPedidos'
import CadastrarSnack from './pages/Admin/CadastrarSnack'
import LoginPage from './pages/Users/Login'
import UsersPage from './pages/Users'
import RegisterPage from './pages/Users/Register'

export function AppRoutes() {
  return (
    <Routes>
      <Route path='/' element={<MainPage />}>
        <Route path='/' element={<BurggerPage />} />
        <Route path='/pizzas' element={<PizzaPage />} />
        <Route path='/drinks' element={<DrinkPage />} />
        <Route path='/ice-creams' element={<IceCreamPage />} />
      </Route>
      <Route path='/cart' element={<MycartPage />}></Route>

      <Route path='/payment' element={<PaymentPage />} />

      <Route path='/admin' element={<AdminPage />}>
        <Route path='/admin/order' element={<AdminPedidos />} />
        <Route path='/admin/register-snack' element={<CadastrarSnack />} />
      </Route>

      <Route path='/users' element={<UsersPage />}>
        <Route path='/users/login' element={<LoginPage />} />
        <Route path='/users/register' element={<RegisterPage />} />
      </Route>

      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  )
}
